module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"header1":"Navn","header2":"Posisjon","header3":"Status nå","header4":"Om 1 time","header5":"Om 2 timer","header6":"Ved tilgjengelig"}}')
  delete Component.options._Ctor
}
